import HttpService from "@front-ends/common/src/utils/api/configs/axiosConfigs";
import { msalConfig, loginRequest, profileRequest } from "../../authConfigLinnae";
import {
  PublicClientApplication,
} from "@azure/msal-browser";

export const msalInstanceLinnae = new PublicClientApplication(msalConfig);

export const RefApi = new HttpService(process.env.REACT_APP_REF_API_URL, msalInstanceLinnae, loginRequest).service;
export const LinnaeApi =new HttpService(process.env.REACT_APP_LINNAE_API_URL, msalInstanceLinnae, loginRequest).service;
export const LinnaeUrl = new HttpService(process.env.REACT_APP_LINNAE_URL, msalInstanceLinnae, profileRequest).service;
